(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[391],{

/***/ 8273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CountUp": function() { return /* binding */ CountUp; }
/* harmony export */ });
var __assign=undefined&&undefined.__assign||function(){return(__assign=Object.assign||function(t){for(var i,n=1,s=arguments.length;n<s;n++)for(var a in i=arguments[n])Object.prototype.hasOwnProperty.call(i,a)&&(t[a]=i[a]);return t}).apply(this,arguments)},CountUp=function(){function t(t,i,n){var s=this;this.endVal=i,this.options=n,this.version="2.3.2",this.defaults={startVal:0,decimalPlaces:0,duration:2,useEasing:!0,useGrouping:!0,smartEasingThreshold:999,smartEasingAmount:333,separator:",",decimal:".",prefix:"",suffix:"",enableScrollSpy:!1,scrollSpyDelay:200,scrollSpyOnce:!1},this.finalEndVal=null,this.useEasing=!0,this.countDown=!1,this.error="",this.startVal=0,this.paused=!0,this.once=!1,this.count=function(t){s.startTime||(s.startTime=t);var i=t-s.startTime;s.remaining=s.duration-i,s.useEasing?s.countDown?s.frameVal=s.startVal-s.easingFn(i,0,s.startVal-s.endVal,s.duration):s.frameVal=s.easingFn(i,s.startVal,s.endVal-s.startVal,s.duration):s.frameVal=s.startVal+(s.endVal-s.startVal)*(i/s.duration);var n=s.countDown?s.frameVal<s.endVal:s.frameVal>s.endVal;s.frameVal=n?s.endVal:s.frameVal,s.frameVal=Number(s.frameVal.toFixed(s.options.decimalPlaces)),s.printValue(s.frameVal),i<s.duration?s.rAF=requestAnimationFrame(s.count):null!==s.finalEndVal?s.update(s.finalEndVal):s.callback&&s.callback()},this.formatNumber=function(t){var i,n,a,e,r=t<0?"-":"";i=Math.abs(t).toFixed(s.options.decimalPlaces);var o=(i+="").split(".");if(n=o[0],a=o.length>1?s.options.decimal+o[1]:"",s.options.useGrouping){e="";for(var l=0,h=n.length;l<h;++l)0!==l&&l%3==0&&(e=s.options.separator+e),e=n[h-l-1]+e;n=e}return s.options.numerals&&s.options.numerals.length&&(n=n.replace(/[0-9]/g,function(t){return s.options.numerals[+t]}),a=a.replace(/[0-9]/g,function(t){return s.options.numerals[+t]})),r+s.options.prefix+n+a+s.options.suffix},this.easeOutExpo=function(t,i,n,s){return n*(1-Math.pow(2,-10*t/s))*1024/1023+i},this.options=__assign(__assign({},this.defaults),n),this.formattingFn=this.options.formattingFn?this.options.formattingFn:this.formatNumber,this.easingFn=this.options.easingFn?this.options.easingFn:this.easeOutExpo,this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.endVal=this.validateValue(i),this.options.decimalPlaces=Math.max(this.options.decimalPlaces),this.resetDuration(),this.options.separator=String(this.options.separator),this.useEasing=this.options.useEasing,""===this.options.separator&&(this.options.useGrouping=!1),this.el="string"==typeof t?document.getElementById(t):t,this.el?this.printValue(this.startVal):this.error="[CountUp] target is null or undefined","undefined"!=typeof window&&this.options.enableScrollSpy&&(this.error?console.error(this.error,t):(window.onScrollFns=window.onScrollFns||[],window.onScrollFns.push(function(){return s.handleScroll(s)}),window.onscroll=function(){window.onScrollFns.forEach(function(t){return t()})},this.handleScroll(this)))}return t.prototype.handleScroll=function(t){if(t&&window&&!t.once){var i=window.innerHeight+window.scrollY,n=t.el.getBoundingClientRect(),s=n.top+n.height+window.pageYOffset;s<i&&s>window.scrollY&&t.paused?(t.paused=!1,setTimeout(function(){return t.start()},t.options.scrollSpyDelay),t.options.scrollSpyOnce&&(t.once=!0)):window.scrollY>s&&!t.paused&&t.reset()}},t.prototype.determineDirectionAndSmartEasing=function(){var t=this.finalEndVal?this.finalEndVal:this.endVal;this.countDown=this.startVal>t;var i=t-this.startVal;if(Math.abs(i)>this.options.smartEasingThreshold&&this.options.useEasing){this.finalEndVal=t;var n=this.countDown?1:-1;this.endVal=t+n*this.options.smartEasingAmount,this.duration=this.duration/2}else this.endVal=t,this.finalEndVal=null;null!==this.finalEndVal?this.useEasing=!1:this.useEasing=this.options.useEasing},t.prototype.start=function(t){this.error||(this.callback=t,this.duration>0?(this.determineDirectionAndSmartEasing(),this.paused=!1,this.rAF=requestAnimationFrame(this.count)):this.printValue(this.endVal))},t.prototype.pauseResume=function(){this.paused?(this.startTime=null,this.duration=this.remaining,this.startVal=this.frameVal,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count)):cancelAnimationFrame(this.rAF),this.paused=!this.paused},t.prototype.reset=function(){cancelAnimationFrame(this.rAF),this.paused=!0,this.resetDuration(),this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.printValue(this.startVal)},t.prototype.update=function(t){cancelAnimationFrame(this.rAF),this.startTime=null,this.endVal=this.validateValue(t),this.endVal!==this.frameVal&&(this.startVal=this.frameVal,null==this.finalEndVal&&this.resetDuration(),this.finalEndVal=null,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count))},t.prototype.printValue=function(t){var i=this.formattingFn(t);"INPUT"===this.el.tagName?this.el.value=i:"text"===this.el.tagName||"tspan"===this.el.tagName?this.el.textContent=i:this.el.innerHTML=i},t.prototype.ensureNumber=function(t){return"number"==typeof t&&!isNaN(t)},t.prototype.validateValue=function(t){var i=Number(t);return this.ensureNumber(i)?i:(this.error="[CountUp] invalid start or end value: ".concat(t),null)},t.prototype.resetDuration=function(){this.startTime=null,this.duration=1e3*Number(this.options.duration),this.remaining=this.duration},t}();

/***/ }),

/***/ 5161:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/earn",
      function () {
        return __webpack_require__(820);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; },
/* harmony export */   "q": function() { return /* binding */ IconContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9521);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  border-radius: ",
        ";\n  padding-left: 3rem;\n  font-family: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  width: 2.4rem;\n  height: 2.4rem;\n  top: -0.3rem;\n  left: 0;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}

const Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b02ec62-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.borderRadius.main;
}, (param)=>{
    let { theme  } = param;
    return theme.fonts.archivo;
}, (param)=>{
    let { type , theme: { colors: { primary: { main  } , secondary: { red , green , yellow  }  }  }  } = param;
    switch(type){
        case "error":
            return "\n          color: ".concat(red, ";\n          fill: ").concat(red, ";\n        ");
        case "info":
            return "\n          color: ".concat(main, ";\n          fill: ").concat(main, ";\n        ");
        case "success":
            return "\n          color: ".concat(green, ";\n          fill: ").concat(green, ";\n        ");
        case "warning":
            return "\n          color: ".concat(yellow, ";\n          fill: ").concat(yellow, ";\n        ");
    }
});
const IconContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b02ec62-1"
})(_templateObject1());


/***/ }),

/***/ 820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Earn; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/common/Link/index.tsx + 1 modules
var Link = __webpack_require__(157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./components/common/Typography/index.tsx + 1 modules
var Typography = __webpack_require__(990);
// EXTERNAL MODULE: ./components/common/Alert/Alert.styles.ts
var Alert_styles = __webpack_require__(4309);
;// CONCATENATED MODULE: ./pages/earn/EarnHero.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 100px;\n  display: flex;\n  justify-content: space-between;\n  > section {\n    width: 450px;\n  }\n  > svg {\n    width: 470px;\n    aspect-ratio: 1.6;\n  }\n  padding-bottom: 64px;\n  @media (max-width: ",
        ") {\n    padding-top: 20px;\n    padding-bottom: 48px;\n    flex-direction: column;\n    gap: 32px;\n    > section {\n      width: 100%;\n    }\n    > svg {\n      width: 360px;\n    }\n  }\n  @media (max-width: ",
        ") {\n    > svg {\n      width: 100%;\n    }\n  }\n  ",
        " {\n    width: 340px;\n    max-width: 90%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 47px;\n  margin-bottom: 16px;\n  width: 40rem;\n  display: block;\n  @media (max-width: ",
        ") {\n    width: 35rem;\n  }\n  @media (max-width: ",
        ") {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  color: ",
        ";\n  @media (max-width: ",
        ") {\n    display: inline;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 0 24px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n  @media (max-width: ",
        ") {\n    width: 440px;\n  }\n  @media (max-width: ",
        ") {\n    width: auto;\n    gap: 32px;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\nalign-self: flex-end;\npadding: 0 24px 24px 0;\n@media (max-width: ",
        ") {\n  padding-bottom: 0;\n}\n@media (max-width: ",
        ") {\n  :first-child {\n    width: auto\n  }\n}\n> strong, > b {\n    font-size: 24px;\n    display: block;\n    color: ",
        ";\n    font-family: ",
        ";\n    line-height: 1;\n    font-weight: 700;\n}\n> strong {\n    font-size: 36px;\n}\nlabel {\n    font-size: 16px;\n    display: block;\n    padding-top: 8px;\n    color: ",
        ";\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}



/*
====================
Hero Section
====================
 */ const HeroWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c17b79a1-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
}, Alert_styles/* Container */.W);
const HeroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
    componentId: "sc-c17b79a1-1"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const Highlight = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c17b79a1-2"
})(_templateObject2(), (param)=>{
    let { theme: { colors: { primary: { main  }  }  }  } = param;
    return main;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const HeroData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c17b79a1-3"
})(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const DataItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c17b79a1-4"
})(_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
}, (param)=>{
    let { theme: { colors: { primary: { main  }  }  }  } = param;
    return main;
}, (param)=>{
    let { theme: { fonts: { spaceGrotesk  }  }  } = param;
    return spaceGrotesk;
}, (param)=>{
    let { theme: { colors: { functional: { darkGray  }  }  }  } = param;
    return darkGray;
});

// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(7857);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./public/earn/earn.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgEarn = function SvgEarn(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 306 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "m148.105 79.019 5.438 3.146-.278 5.956-5.283-2.932.123-6.17ZM142.454 79.019l.492 6.17-4.577 2.594-1.049-6.02 5.134-2.744ZM133.514 87.47l1.411 5.585-2.363 7.372-1.353-5.273 2.305-7.684ZM138.673 92.717l4.085-2.406-.123 4.441-3.806 2.126-.156-4.16ZM147.458 90.37l4.61 2.744-1.658 3.92-3.962-2.438 1.01-4.226ZM155.997 98.178l3.166 6.781-2.363 1.885-2.797-5.832 1.994-2.834ZM158.458 88.21l3.716 8.238-.952 4.655-3.593-7.554.829-5.338ZM152.618 75.995l5.134 6.17-.712-5.37-4.694-6.138.272 5.338ZM146.694 67.296l.395 5.552-5.742-.215-.156-5.493 5.503.156ZM136.466 70.41l-.156 5.461-4.085 5.644-.032-4.473 2.363-4.564 1.91-2.068ZM129.519 87.009l.648 2.776-.984 8.484-.246-6.046.582-5.214ZM135.138 97.56l-1.961 6.444 1.379 2.282 1.722-5.579-1.14-3.146ZM138.673 102.619l5.652 1.047-1.198 3.855-5.865.033 1.411-4.935ZM136.582 112.735l6.208-.988.46 4.688-5.93 2.314-.738-6.014ZM139.075 123.625l5.619-2.496 2.059 3.641-5.315 3.732-2.363-4.877ZM144.267 131.401l3.593 1.632 3.871-4.655-2.706-1.235-4.758 4.258ZM147.122 136.459l3.903-.188 1.224 2.034-3.93.651-1.165-.306-.032-2.191ZM143.16 134.639v2.002l-4.208-4.44.369-1.144 3.839 3.582ZM136.155 126.492l.278-.709-1.566-6.137-1.23-.312 2.518 7.158ZM170.402 106.162l.861 3.582 11.213-1.911-.829-3.368-11.245 1.697ZM192.982 100.921l.583 3.238 8.539-3.92-.77-3.544-8.352 4.226ZM194.09 107.365l-.803 3.303-11.517 3.303.706-2.867 11.614-3.739ZM178.481 99.654l1.877 1.82 10.993-3.172-1.839-1.977-11.031 3.329ZM169.424 119.646l11.271-3.147-1.935 2.25-11.058 3.302 1.722-2.405ZM200.602 110.023l-1.909 2.868-7.678 2.373 1.353-2.25 8.234-2.991ZM202.195 103.483l-.214 3.7 2.15-2.035.615-4.382-2.551 2.717ZM197.741 92.346l1.812 1.88 2.674-5.8-2.486-1.632-2 5.552ZM195.067 87.562l2.402-1.106-3.567-6.638-2.24 1.82 3.405 5.924ZM191.507 92.223l1.508-2.867-3.198-5.156-1.534 4.103 3.224 3.92ZM186.962 93.237l-.214 2.47.492-.123 1.994-1.02-2.272-1.327ZM183.673 75.592l-1.534 3.673-9.4-4.044.246-4.375 10.688 4.746ZM180.604 84.512l-.647 6.014-8.293-2.01.304-7.307 8.636 3.303ZM158.425 72.205l1.78 7.86 4.668-.123-.583-7.25-5.865-.487ZM156.243 66.496l7.374 1.17-.803-3.55-9.426-1.475 2.855 3.855Z",
    stroke: "#3763FF"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m148.565 63.812 4.487 4.011-.706 2.835-5.652-3.362 1.871-3.485ZM147.089 72.848l1.017 6.17h-5.652l-1.107-6.384 5.742.214ZM136.465 70.41l4.726-3.27.156 5.493-5.037 3.238.155-5.461ZM133.514 87.47l3.806-5.708 1.049 6.02-3.444 5.273-1.411-5.585ZM142.946 85.189h5.037l-.525 5.181-4.7-.058.188-5.123ZM153.266 88.12l4.363 5.429-1.631 4.629-3.93-5.065 1.198-4.993ZM152.618 75.995l.926 6.17 4.914 6.046-.706-6.046-5.134-6.17Z",
    stroke: "#3763FF"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "m147.089 72.849 5.529 3.146.926 6.17-5.438-3.146-1.017-6.17ZM141.347 72.634l1.107 6.384-5.134 2.744-1.01-5.89 5.037-3.238ZM132.225 81.515l1.288 5.955-2.304 7.685-1.042-5.37 2.058-8.27ZM138.369 87.783l4.577-2.594-.188 5.123-4.085 2.405-.304-4.934Z",
    stroke: "#3763FF"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "m142.635 94.752 3.813-.156 1.01-4.226-4.7-.059-.123 4.441ZM141.01 99.472l2.946-1.788 4.765 1.697-2.46 1.449-5.251-1.358ZM136.278 100.707l2.395 1.911-1.411 4.935-2.706-1.268 1.722-5.578ZM136.582 112.735l.68-5.182 5.865-.032-.337 4.225-6.208.989ZM137.32 118.749l1.755 4.876 5.619-2.496-1.444-4.694-5.93 2.314ZM141.438 128.501l2.829 2.9 4.758-4.258-2.272-2.373-5.315 3.731ZM147.86 133.033l3.282-.338 2.551-4.226-1.962-.091-3.871 4.655ZM143.16 134.639l3.962 1.82.032 2.191-3.994-2.009v-2.002ZM138.951 132.2l.37-1.144-2.888-5.273-.278.709 2.796 5.708ZM133.636 119.334l-1.107-8.264 1.509 1.632.828 6.944-1.23-.312Z",
    stroke: "#3763FF"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "m133.177 104.004 1.379 2.282-.518 6.417-1.509-1.632.648-7.067ZM134.925 93.055l.214 4.505-1.962 6.443-.615-3.576 2.363-7.372ZM136.278 100.707l2.551-3.83 2.181 2.595-2.337 3.147-2.395-1.912ZM142.635 94.752l3.813-.156 1.01 2.9-3.502.188-1.321-2.932Z",
    stroke: "#3763FF"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "m135.139 97.56 3.534-4.843.156 4.16-2.551 3.83-1.139-3.147ZM131.209 95.155l-.641 9.037.952 4.844 1.042-8.608-1.353-5.273Z",
    stroke: "#3763FF"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "m133.636 119.334-2.116-10.299 1.009 2.035 1.107 8.264ZM130.568 104.192l-1.385-5.922.984-8.485 1.042 5.37-.641 9.037Z",
    stroke: "#3763FF"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "m131.52 109.036-1.541-2.75-.796-8.017 1.385 5.923.952 4.844Z",
    stroke: "#3763FF"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "m133.637 119.334-3.658-13.049 1.541 2.75 2.117 10.299ZM134.867 119.646l2.453-.897 1.755 4.876-2.642 2.159-1.566-6.138ZM134.038 112.702l2.544.033.68-5.182-2.706-1.268-.518 6.417ZM141.01 99.472l-2.337 3.146 5.652 1.047 1.936-2.835-5.251-1.358ZM143.127 107.521l9.096-1.08-.369 4.103-9.063 1.203.336-4.226ZM143.25 116.434l9.336-2.002 1.016 3.393-8.908 3.303-1.444-4.694ZM146.752 124.769l8.695-3.582 1.502 1.943-.026.124-7.898 3.888-2.273-2.373ZM151.731 128.378l4.758-3.271-.369 1.6-2.427 1.762-1.962-.091Z",
    stroke: "#3763FF"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "m151.854 110.544.731 3.888-9.335 2.002-.459-4.687 9.063-1.203ZM153.602 117.825l1.845 3.361-8.694 3.583-2.059-3.641 8.908-3.303ZM156.923 123.255l-.434 1.853-4.758 3.27-2.706-1.235 7.898-3.888ZM144.325 103.666l8.695-.156-.797 2.932-9.096 1.079 1.198-3.855Z",
    stroke: "#3763FF"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    d: "m146.26 100.831 5.594.273 1.256 1.45-.091.956-8.694.156 1.935-2.835ZM152.067 93.113l-1.657 3.92 3.593 3.98 1.994-2.835-3.93-5.065ZM157.628 93.549l-1.631 4.629 3.166 6.781 2.058-3.855-3.593-7.555ZM147.458 97.495l3.166 2.224-.214-2.685-3.962-2.438 1.01 2.9Z",
    stroke: "#3763FF"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "m154.003 101.013-.582 1.886-2.797-3.18-.214-2.685 3.593 3.979Z",
    stroke: "#3763FF"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    d: "m156.8 106.845-1.016 1.137-2.363-5.084.583-1.885 2.796 5.832Z",
    stroke: "#3763FF"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    d: "m158.516 113.879-.984-.032-1.748-5.865 1.016-1.137 1.716 7.034ZM159.163 104.959l1.968 7.808-2.615 1.112-1.716-7.035 2.363-1.885Z",
    stroke: "#3763FF"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M158.852 120.446h-1.288l-.032-6.599.984.032.336 6.567Z",
    stroke: "#3763FF"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    d: "m161.131 112.768.363 7.71-2.642-.032-.336-6.567 2.615-1.111Z",
    stroke: "#3763FF"
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    d: "m160.115 127.389 1.379-6.911-2.642-.033-1.01 6.606 2.273.338ZM155.596 132.201l1.968 1.235 2.55-6.046-2.272-.338-2.246 5.149Z",
    stroke: "#3763FF"
  })), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    d: "m151.025 136.27 1.224 2.035 5.315-4.87-1.968-1.235-4.571 4.07Z",
    stroke: "#3763FF"
  })), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    d: "m151.142 132.695-.117 3.576 4.571-4.07-1.321-1.944-3.133 2.438ZM157.564 120.445l-1.444 6.261 1.722.345 1.01-6.606h-1.288Z",
    stroke: "#3763FF"
  })), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
    d: "m154.275 130.257 1.321 1.944 2.246-5.149-1.722-.345-1.845 3.55ZM147.86 133.032l-.738 3.427 3.903-.189.117-3.576-3.282.338ZM144.267 131.4l-1.107 3.238 3.962 1.821.738-3.427-3.593-1.632Z",
    stroke: "#3763FF"
  })), _path21 || (_path21 = /*#__PURE__*/react.createElement("path", {
    d: "m141.438 128.501-2.117 2.555 3.839 3.582 1.107-3.237-2.829-2.9ZM139.074 123.625l-2.641 2.158 2.887 5.273 2.117-2.555-2.363-4.876ZM161.222 101.104l2.026 9.258-2.117 2.405-1.968-7.808 2.059-3.855Z",
    stroke: "#3763FF"
  })), _path22 || (_path22 = /*#__PURE__*/react.createElement("path", {
    d: "m161.493 120.479 2.305-2.282-.55-7.835-2.117 2.406.362 7.711ZM171.263 109.744l.155 3.979 11.057-2.62v-3.27l-11.212 1.911ZM170.59 116.87l-1.166 2.777 11.271-3.147 1.075-2.529-11.18 2.899ZM170.402 106.162l-1.47-3.114 11.427-1.573 1.288 2.99-11.245 1.697ZM191.351 98.302l1.631 2.62 8.352-4.226-1.781-2.47-8.202 4.076ZM193.565 104.16l.525 3.205 8.105-3.881-.091-3.245-8.539 3.921ZM193.287 110.667l-.919 2.347 8.234-2.99 1.379-2.841-8.694 3.484Z",
    stroke: "#3763FF"
  })), _path23 || (_path23 = /*#__PURE__*/react.createElement("path", {
    d: "m178.759 118.749 12.255-3.485 1.353-2.249-11.672 3.484-1.936 2.25ZM181.647 104.465l11.336-3.543.582 3.238-11.089 3.673-.829-3.368ZM178.481 99.654l-2.149-1.417 10.908-2.653 2.272.741-11.031 3.329ZM166.964 100.799l1.968 2.249 11.426-1.573-1.877-1.82-11.517 1.144ZM189.513 96.326l8.228-3.98 1.813 1.88-8.203 4.076-1.838-1.976ZM195.223 91.514l2.518.832 2-5.552-2.272-.338-2.246 5.058ZM202.227 88.426l1.781 3.394-2.674 4.876-1.78-2.47 2.673-5.8ZM202.104 100.239l2.641-4.902v5.429l-2.55 2.717-.091-3.244ZM204.13 105.147l-1.534 4.038-1.994.839 1.379-2.842 2.149-2.035ZM198.692 112.891l2.829-2.132 1.075-1.573-1.994.838-1.91 2.867Z",
    stroke: "#3763FF"
  })), _path24 || (_path24 = /*#__PURE__*/react.createElement("path", {
    d: "m204.008 91.82.738 3.517-2.642 4.902-.77-3.544 2.674-4.876ZM202.227 88.426l-1.599-3.543-3.437-4.012-.861-.682 2.945 4.2.466 2.405 2.486 1.632Z",
    stroke: "#3763FF"
  })), _path25 || (_path25 = /*#__PURE__*/react.createElement("path", {
    d: "m193.902 79.818 2.428.37 2.945 4.2.466 2.406-2.272-.338-3.567-6.638ZM191.662 81.639l-1.845 2.561 3.198 5.156 2.052-1.794-3.405-5.923ZM188.282 88.302l-1.32 4.935-7.005-2.711.647-6.014 7.678 3.79Z",
    stroke: "#3763FF"
  })), _path26 || (_path26 = /*#__PURE__*/react.createElement("path", {
    d: "m182.139 79.265 7.678 4.935 1.845-2.562-7.989-6.046-1.534 3.673ZM172.739 75.222l-.771 5.988 8.636 3.302 1.535-5.246-9.4-4.044ZM171.664 88.517l-.123 7.1 8.325.708.091-5.8-8.293-2.008Z",
    stroke: "#3763FF"
  })), _path27 || (_path27 = /*#__PURE__*/react.createElement("path", {
    d: "m164.873 79.941.032 8.147 6.759.429.304-7.308-7.095-1.268ZM164.29 72.693l8.449 2.529.246-4.376-9.368-3.179.673 5.026Z",
    stroke: "#3763FF"
  })), _path28 || (_path28 = /*#__PURE__*/react.createElement("path", {
    d: "m174.124 67.947-1.139 2.9-9.368-3.18-.803-3.55 11.31 3.83ZM183.673 75.591l2.642-2.34 7.587 6.566-2.24 1.82-7.989-6.046Z",
    stroke: "#3763FF"
  })), _path29 || (_path29 = /*#__PURE__*/react.createElement("path", {
    d: "m174.124 67.946 12.191 5.305-2.642 2.341-10.688-4.746 1.139-2.9Z",
    stroke: "#3763FF"
  })), _path30 || (_path30 = /*#__PURE__*/react.createElement("path", {
    d: "m196.33 80.188-2.428-.37-7.588-6.567 10.016 6.937ZM153.388 62.64l-4.823 1.17 4.487 4.012 3.191-1.326-2.855-3.855ZM158.425 72.204l-2.182-5.708 7.374 1.17.673 5.026-5.865-.488ZM160.205 80.065l4.668-.124.032 8.147-2.978.8-1.722-8.823Z",
    stroke: "#3763FF"
  })), _path31 || (_path31 = /*#__PURE__*/react.createElement("path", {
    d: "m165.242 95.799-.337-7.711 6.759.429-.123 7.1-6.299.182ZM176.332 98.236l-11.427 1.236 2.059 1.326 11.517-1.144-2.149-1.418ZM171.418 113.724l-.829 3.146 11.181-2.899.705-2.867-11.057 2.62ZM195.223 91.514l-7.983 4.07 2.273.74 8.228-3.978-2.518-.832ZM162.173 96.448l2.363 11.878-1.288 2.035-2.026-9.258.951-4.655ZM163.798 118.196l.615-1.046.123-8.823-1.288 2.035.55 7.834ZM157.752 82.165l4.668 11.352-.246 2.932-3.716-8.238-.706-6.046Z",
    stroke: "#3763FF"
  })), _path32 || (_path32 = /*#__PURE__*/react.createElement("path", {
    d: "m157.04 76.795 5.379 16.722-4.667-11.352-.712-5.37ZM163.798 118.196l-1.443 8.667-2.24.526 1.379-6.911 2.304-2.282Z",
    stroke: "#3763FF"
  })), _path33 || (_path33 = /*#__PURE__*/react.createElement("path", {
    d: "m157.564 133.435 2.305-.214 2.486-6.359-2.24.527-2.551 6.046ZM152.249 138.306l.401.526 7.219-5.61-2.305.214-5.315 4.87ZM148.319 138.956l4.331-.124-.401-.526-3.93.65ZM153.052 67.822l3.988 6.814v2.158l-4.694-6.137.706-2.835ZM148.565 63.811l-3.904-.461-3.47 3.79 5.503.156 1.871-3.485Z",
    stroke: "#3763FF"
  })), _path34 || (_path34 = /*#__PURE__*/react.createElement("path", {
    d: "m136.466 70.41 2.667-3.576 5.529-3.484-3.47 3.79-4.726 3.27ZM153.388 62.64l-4.454-.279-4.272.989 3.903.461 4.823-1.17ZM157.04 74.636l1.385-2.432-2.182-5.708-3.191 1.326 3.988 6.814ZM162.419 93.517l2.117 14.81-2.363-11.878.246-2.932ZM157.04 74.637l1.968 5.864 1.197-.436-1.78-7.86-1.385 2.432Z",
    stroke: "#3763FF"
  })), _path35 || (_path35 = /*#__PURE__*/react.createElement("path", {
    d: "m161.928 88.887-1.723-8.823-1.197.436 2 8.634.92-.247Z",
    stroke: "#3763FF"
  })), _path36 || (_path36 = /*#__PURE__*/react.createElement("path", {
    d: "m165.242 95.799-2.331 1.111-.492-3.393-.492-4.63 2.978-.8.337 7.712ZM179.866 96.325l2.577.43-2.732.682.155-1.112ZM171.541 95.616l.032 3.147 4.759-.527 3.379-.8.155-1.111-8.325-.709Z",
    stroke: "#3763FF"
  })), _path37 || (_path37 = /*#__PURE__*/react.createElement("path", {
    d: "m165.242 95.798-.337 3.674 6.668-.71-.032-3.146-6.299.182ZM170.402 106.162l-6.079.559.213 1.606-.032 3.173 6.759-1.756-.861-3.582ZM171.418 113.724l-6.972 1.729-.033 1.697-.304 2.34 6.48-2.62.829-3.146ZM169.424 119.646l-5.626 1.756-.615 2.347 4.519-1.697 1.722-2.406ZM171.263 109.744l.155 3.979-6.972 1.729.058-3.952 6.759-1.756Z",
    stroke: "#3763FF"
  })), _path38 || (_path38 = /*#__PURE__*/react.createElement("path", {
    d: "m170.589 116.87-1.165 2.776-5.626 1.756.311-1.912 6.48-2.62ZM151.854 110.544l4.454-.8 1.042 3.517-4.764 1.171-.732-3.888ZM153.602 117.826l3.93-1.112.032 3.426-2.117 1.047-1.845-3.361ZM152.223 106.441l2.855.033.706 1.508.524 1.762-4.454.8.369-4.103ZM129.519 87.009l2.674-9.967.032 4.473-2.059 8.27-.647-2.776ZM168.932 103.048l-5.069.461.46 3.212 6.079-.559-1.47-3.114ZM166.964 100.798l-3.438.338.337 2.373 5.069-.462-1.968-2.249Z",
    stroke: "#3763FF"
  })), _path39 || (_path39 = /*#__PURE__*/react.createElement("path", {
    d: "m164.905 99.472-1.625.09.246 1.574 3.438-.338-2.059-1.326ZM195.067 87.561l-1.871 5 2.027-1.047 2.246-5.058-2.402 1.105ZM193.015 89.356l-1.23 3.914 1.411-.709 1.871-5-2.052 1.795Z",
    stroke: "#3763FF"
  })), _path40 || (_path40 = /*#__PURE__*/react.createElement("path", {
    d: "m191.507 92.223-1.289 1.853 1.567-.807 1.23-3.913-1.508 2.867ZM191.351 98.302l-10.993 3.172 1.289 2.991 11.335-3.543-1.631-2.62ZM193.565 104.159l.525 3.205-11.614 3.739v-3.27l11.089-3.674ZM193.287 110.668l.802-3.303 8.106-3.882-.214 3.7-8.694 3.485ZM180.695 116.5l11.673-3.485.919-2.347-11.517 3.303-1.075 2.529ZM179.957 90.525l7.005 2.712-.214 2.47-4.305 1.047-2.576-.43.09-5.799Z",
    stroke: "#3763FF"
  })), _path41 || (_path41 = /*#__PURE__*/react.createElement("path", {
    d: "m188.283 88.303-1.321 4.934 2.272 1.327.984-.488 1.289-1.853-3.224-3.92ZM182.139 79.266l7.678 4.934-1.534 4.103-7.679-3.79 1.535-5.247ZM164.291 72.692l8.448 2.53-.77 5.987-7.096-1.267-.582-7.25ZM153.544 82.165l4.913 6.046-.828 5.338-4.364-5.429.279-5.955Z",
    stroke: "#3763FF"
  })), _path42 || (_path42 = /*#__PURE__*/react.createElement("path", {
    d: "m147.983 85.189 5.283 2.932-1.198 4.993-4.61-2.744.525-5.181Z",
    stroke: "#3763FF"
  })), _path43 || (_path43 = /*#__PURE__*/react.createElement("path", {
    d: "M142.454 79.019h5.652l-.123 6.17h-5.037l-.492-6.17ZM146.694 67.296l5.652 3.361.272 5.338-5.529-3.147-.395-5.552ZM136.31 75.871l-4.085 5.643 1.288 5.956 3.807-5.709-1.01-5.89ZM138.369 87.782l-3.444 5.273.213 4.505 3.535-4.843-.304-4.935ZM142.635 94.752l-3.806 2.126 2.181 2.594 2.946-1.788-1.321-2.932ZM132.562 100.428l.615 3.576-.648 7.067-1.009-2.035 1.042-8.608ZM134.038 112.702l2.544.033.738 6.014-2.453.897-.829-6.944ZM152.585 114.432l1.017 3.394 3.929-1.112v-2.867l-.181-.585-4.765 1.17ZM155.447 121.187l1.502 1.944.615-2.685v-.305l-2.117 1.046ZM151.142 132.695l3.133-2.438 1.845-3.55-2.427 1.762-2.551 4.226ZM165.242 95.799l-2.33 1.112.369 2.652 1.625-.09.336-3.674ZM146.261 100.831l2.46-1.45 1.903.338 1.23 1.385-5.593-.273ZM152.223 106.442l.796-2.932.706.065 1.353 2.899-2.855-.032Z",
    stroke: "#3763FF"
  })), _path44 || (_path44 = /*#__PURE__*/react.createElement("path", {
    d: "m143.956 97.684 3.502-.189 3.166 2.224-1.903-.338-4.765-1.697ZM162.354 126.863l1.444-5.462.615-4.252-.615 1.047-1.444 8.667ZM153.11 102.554l.311.344.304.676-.705-.065.09-.955ZM157.04 74.636v2.158l3.968 12.34-2-8.634-1.968-5.864ZM161.928 88.888l-.92.247 1.412 4.382-.492-4.63Z",
    stroke: "#3763FF"
  })), _path45 || (_path45 = /*#__PURE__*/react.createElement("path", {
    d: "M278.457 122.006c14.301 0 25.895-11.644 25.895-26.006s-11.594-26.006-25.895-26.006S252.562 81.638 252.562 96s11.594 26.006 25.895 26.006Z",
    stroke: "#3763FF",
    strokeWidth: 2
  })), _path46 || (_path46 = /*#__PURE__*/react.createElement("path", {
    d: "m272.029 89.635-11.757-11.807v36.526l9.089-9.129v-9.128a9.12 9.12 0 0 1 2.661-6.456l.007-.006Z",
    stroke: "#3763FF"
  })), _path47 || (_path47 = /*#__PURE__*/react.createElement("path", {
    d: "M278.457 86.963c5.024 0 9.089 4.09 9.089 9.128v9.128l9.09 9.128V77.828h-36.364l11.757 11.807a9.052 9.052 0 0 1 6.428-2.672Z",
    stroke: "#3763FF"
  })), _path48 || (_path48 = /*#__PURE__*/react.createElement("path", {
    d: "m278.457 96.091 9.089 9.128v-9.128c0-5.045-4.072-9.128-9.089-9.128a9.043 9.043 0 0 0-6.429 2.672l2.525 2.536 3.904 3.92Z",
    stroke: "#3763FF"
  })), _path49 || (_path49 = /*#__PURE__*/react.createElement("path", {
    d: "M272.028 89.635a9.12 9.12 0 0 0-2.66 6.456v9.128l9.089-9.128-6.429-6.456ZM287.546 105.226h-18.185l-9.089 9.128h36.37l-9.096-9.128Z",
    stroke: "#3763FF"
  })), _path50 || (_path50 = /*#__PURE__*/react.createElement("path", {
    d: "m278.457 96.09-9.089 9.129h18.185l-9.09-9.128h-.006Z",
    stroke: "#3763FF"
  })), _path51 || (_path51 = /*#__PURE__*/react.createElement("path", {
    d: "M216.949 96h17.091M226.789 87.905l8.267 8.303-7.846 7.886M95.622 95.291h11.271M53.438 27.656c0 14.414-11.543 26.006-25.895 26.006-14.353 0-25.896-11.592-25.896-26.006C1.647 13.243 13.19 1.65 27.543 1.65c14.352 0 25.895 11.593 25.895 26.006Z",
    stroke: "#3763FF",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/react.createElement("path", {
    d: "M30.599 23.138c.142.422.55.695.97.695h1.742a.959.959 0 0 0 .978-.981v-.15c-.447-2.438-2.39-4.33-4.895-4.636v-2.425c0-.578-.44-.968-1.042-1.085h-1.67c-.576 0-.965.442-1.081 1.046v2.36c-3.244.508-5.335 2.738-5.335 5.546 0 1.853.563 3.18 1.742 4.11 1.165.91 2.9 1.41 5.185 1.683 1.522.273 2.48.566 3.062.988.285.208.473.436.596.715.123.28.181.618.181 1.034 0 1.587-1.379 2.73-3.373 2.73-1.385 0-2.285-.292-2.874-.76-.583-.461-.893-1.118-1.049-1.905v-.013c-.13-.533-.544-.819-.97-.819h-1.852a.959.959 0 0 0-.978.982v.143c.227 1.404.79 2.626 1.767 3.563.946.91 2.266 1.54 4.001 1.833v2.438c0 .579.44.969 1.043 1.086H28.416c.577 0 .965-.442 1.082-1.047V37.792c3.25-.618 5.438-2.952 5.438-5.975 0-1.963-.59-3.316-1.8-4.245-1.19-.91-2.952-1.379-5.244-1.658-1.625-.215-2.55-.54-3.075-.962-.498-.41-.654-.93-.654-1.658 0-.729.253-1.268.732-1.658.492-.397 1.256-.637 2.311-.637.958 0 1.67.162 2.208.5.53.338.913.859 1.172 1.645l.013-.006Z",
    stroke: "#3763FF",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/react.createElement("path", {
    d: "m22.118 43.097-.02-.013h-.026c-8.37-3.03-12.663-12.405-9.555-20.707 1.612-4.525 5.153-7.977 9.555-9.596h.013l.013-.007c.246-.123.44-.286.576-.507.136-.22.195-.481.195-.787V9.954c0-.254-.065-.495-.207-.69a1.047 1.047 0 0 0-.615-.396h-.026l-.026-.007c-.052 0-.15 0-.253.02a.669.669 0 0 0-.291.117C11.028 12.326 5.324 23.469 8.62 33.95c1.98 6.183 6.7 10.929 12.857 12.925.265.13.55.13.783.02a.894.894 0 0 0 .473-.553c.13-.163.13-.338.13-.514V44.268c0-.228-.11-.462-.24-.657a1.974 1.974 0 0 0-.505-.507v-.007Zm10.856-30.232.02.013h.026c8.37 3.03 12.663 12.405 9.555 20.708-1.612 4.525-5.153 7.977-9.555 9.596h-.013l-.013.006c-.246.124-.44.286-.576.507-.136.221-.195.481-.195.787v1.528c0 .254.065.494.208.69.142.194.35.33.615.396h.026l.025.006c.052 0 .15 0 .253-.02a.67.67 0 0 0 .291-.116c10.423-3.33 16.127-14.473 12.831-24.953a19.984 19.984 0 0 0-12.857-13.03.922.922 0 0 0-.783-.025.894.894 0 0 0-.473.553c-.13.162-.13.338-.13.513V11.584c0 .274.105.534.24.748.136.215.324.403.512.527l-.007.006Z",
    stroke: "#3763FF",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/react.createElement("path", {
    d: "M27.543 138.338c14.3 0 25.895 11.644 25.895 26.006S41.844 190.35 27.543 190.35c-14.3 0-25.896-11.644-25.896-26.006s11.595-26.006 25.896-26.006Z",
    stroke: "#3763FF",
    strokeWidth: 2
  })), _path55 || (_path55 = /*#__PURE__*/react.createElement("path", {
    d: "M38.542 165.898c0 .039 0 .058-.006.078H18.609v-3.16c.013 0 .045-.006.084-.006h19.745a.24.24 0 0 1 .078.006h.007v.072a19.463 19.463 0 0 1 0 3.01h.019Zm-1.094-6.866s.006.039 0 .059H18.609v-6.001h8.824a11.99 11.99 0 0 1 2.725.292 11.507 11.507 0 0 1 4.804 2.445v.007c.265.201.505.435.712.695v.013l.02.007c.446.448.841.942 1.178 1.482v.013c.22.312.408.644.563.988h.013Zm.02 10.793a10.384 10.384 0 0 1-4.41 4.479h-.122l-.052.033a6.211 6.211 0 0 1-1.152.539c-1.12.43-2.292.69-3.483.774h-.026c-.37.078-.751.104-1.127.078H18.616V169.825H36.839a3.45 3.45 0 0 1 .635-.013v.019l-.007-.006Zm-22.575 5.155v4.161h11.543c1.295.02 2.583-.084 3.858-.312a18.125 18.125 0 0 0 3.898-1.241 19.04 19.04 0 0 0 1.586-.865c.13-.078.259-.15.388-.228h.007l.006-.013a20.483 20.483 0 0 0 1.767-1.424 13.33 13.33 0 0 0 3.483-5.097v-.013l.007-.013a.188.188 0 0 1 .22-.143h3.12c.136 0 .298-.019.415-.149.11-.124.13-.286.13-.436v-1.976c.019-.195.019-.39 0-.585 0-.013 0-.026.006-.052v-.026c.006-.026.02-.066.02-.098a.48.48 0 0 0-.085-.397l-.065-.084H42.42v-.078c.09-1.008.09-2.016 0-3.023v-.059h2.311c.136 0 .298-.013.42-.117.137-.117.156-.279.156-.429v-2.711c0-.078-.006-.163-.02-.221a.405.405 0 0 0-.11-.234.41.41 0 0 0-.239-.098c-.065-.006-.142-.006-.226-.006h-2.965a.206.206 0 0 1-.24-.163v-.019l-.013-.02a13.849 13.849 0 0 0-1.295-2.548 16.11 16.11 0 0 0-1.767-2.211 14.636 14.636 0 0 0-2.913-2.262 16.16 16.16 0 0 0-5.18-1.931c-.88-.163-1.773-.26-2.673-.299H15.424c-.084 0-.168 0-.233.019a.404.404 0 0 0-.214.124.41.41 0 0 0-.084.214c-.007.059-.007.124-.007.182v8.933H11.287c-.071 0-.136 0-.194.013a.39.39 0 0 0-.194.098.34.34 0 0 0-.084.188v3.03c0 .13.012.306.155.403a.427.427 0 0 0 .188.072h3.735v3.166h-4.072v3.335c0 .13.013.306.155.403a.426.426 0 0 0 .188.072H14.9v5.175l-.007-.007Z",
    stroke: "#3763FF",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/react.createElement("path", {
    d: "M27.543 121.297c14.302 0 25.895-11.643 25.895-26.006S41.845 69.285 27.543 69.285 1.647 80.928 1.647 95.291s11.594 26.006 25.896 26.006Z",
    stroke: "#3763FF",
    strokeWidth: 2
  })), _path57 || (_path57 = /*#__PURE__*/react.createElement("path", {
    d: "M14.731 93.003c2.227-.585 5.335-1.014 8.915-1.203v5.43l.2.012c.486.04 1.872.13 3.781.13 2.292 0 3.444-.104 3.658-.123l.194-.02v-5.422c3.567.182 6.675.618 8.895 1.203 1.133.299 2.027.637 2.635.988.622.364.861.709.861 1.001 0 .293-.246.637-.86 1.001-.603.358-1.496.69-2.63.989-2.265.598-5.457 1.033-9.12 1.209-.202.02-1.27.09-3.659.09-1.896 0-3.25-.064-3.722-.084-3.67-.175-6.869-.61-9.141-1.209-1.14-.299-2.033-.637-2.635-.995-.622-.364-.868-.708-.868-1 0-.293.246-.638.868-1.002.602-.358 1.502-.696 2.635-.995h-.007Zm26.996-.67c-2.576-.767-6.163-1.313-10.241-1.534v-4.453h10.248v-7.88H13.39v7.88H23.64v4.453c-4.091.215-7.678.767-10.26 1.534-1.315.39-2.383.84-3.121 1.333-.732.488-1.204 1.067-1.204 1.717 0 .65.472 1.229 1.204 1.716.744.494 1.813.943 3.12 1.333 2.583.767 6.176 1.313 10.261 1.534v15.656h7.84V99.96c4.079-.215 7.659-.767 10.242-1.528 1.308-.39 2.376-.832 3.114-1.333.731-.487 1.204-1.06 1.204-1.716 0-.657-.473-1.222-1.204-1.717-.745-.494-1.806-.942-3.114-1.332h.006Z",
    stroke: "#3763FF",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/react.createElement("path", {
    d: "M98.445 95.291c-37.866 0-12.029 70.749-45.006 70.749M98.445 95.291c-37.866 0-12.029-67.622-45.006-67.622M98.445 87.197l8.267 8.303-7.853 7.886",
    stroke: "#3763FF",
    strokeWidth: 2
  })));
};
/* harmony default export */ var earn = (SvgEarn);
// EXTERNAL MODULE: ./components/store/getters.ts
var getters = __webpack_require__(4478);
;// CONCATENATED MODULE: ./pages/earn/EarnHero.tsx






function EarnHero() {
    const formatNumberWithCommas = (value)=>{
        return value.toLocaleString();
    };
    const lpApy = (0,getters/* useLpAPY */.T7)();
    const tvl = (0,getters/* useTvl */.jT)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroTitle, {
                            type: "h1",
                            children: [
                                "Earn ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight, {
                                    children: "passive income"
                                }),
                                " as a Liquidity Provider"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Provide liquidity to our 3CRV/lvUSD Curve Pool, and receive ARCH and CRV as rewards."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroData, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                children: [
                                                    !lpApy && "--",
                                                    lpApy && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                                                useEasing: true,
                                                                duration: 2,
                                                                end: lpApy,
                                                                decimals: 2,
                                                                formattingFn: formatNumberWithCommas
                                                            }),
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: "Live"
                                                    }),
                                                    " Pool APY"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                children: [
                                                    !tvl && "--",
                                                    tvl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            "$",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                                                useEasing: true,
                                                                duration: 2,
                                                                end: tvl,
                                                                decimals: 0,
                                                                formattingFn: formatNumberWithCommas
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: "Live"
                                                    }),
                                                    " Pool TVL"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                target: "_blank",
                                href: "https://curve.fi/#/ethereum/pools/factory-v2-268/deposit",
                                variant: "button",
                                children: "Provide Liquidity on Curve"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            target: "_blank",
                            href: "https://dune.com/archimedesfi/liquidity-provider-dashboard",
                            variant: "outline",
                            children: "Monitor Pool Analytics"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(earn, {})
            ]
        })
    });
}

;// CONCATENATED MODULE: ./pages/earn/EarnSteps.styles.ts

function EarnSteps_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 80px;\n  text-align: center;\n  @media (max-width: ",
        ") {\n  }\n"
    ]);
    EarnSteps_styles_templateObject = function() {
        return data;
    };
    return data;
}
function EarnSteps_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  a:first-child {\n    margin-bottom: 24px;\n  }\n"
    ]);
    EarnSteps_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function EarnSteps_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 48px 0 64px;\n  display: flex;\n  justify-content: center;\n  gap: 24px;\n  width: 920px;\n  margin: 0 auto;\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    width: 288px;\n  }\n"
    ]);
    EarnSteps_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function EarnSteps_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  text-align: left;\n  padding: ",
        ";\n  border-radius: 12px;\n  flex-grow: 1;\n  position: relative;\n  padding-top: calc(90px + ",
        " + 24px);\n  background: ",
        ";\n  box-shadow: ",
        ";\n  p {\n    margin-bottom: 0;\n  }\n  h1 {\n    color: ",
        ";\n    margin-right: 16px;\n  }\n"
    ]);
    EarnSteps_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function EarnSteps_styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% - ",
        " - ",
        ");\n  height: 90px;\n  position: absolute;\n  left: ",
        ";\n  top: ",
        ";\n  right: ",
        ";\n  img {\n    max-height: 90px;\n  }\n  svg {\n    width: 90px;\n    max-height: 80px;\n  }\n"
    ]);
    EarnSteps_styles_templateObject4 = function() {
        return data;
    };
    return data;
}

/*
====================
Steps Section
====================
 */ const StepsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-349b21eb-0"
})(EarnSteps_styles_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});
const StepsButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-349b21eb-1"
})(EarnSteps_styles_templateObject1());
const CardsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-349b21eb-2"
})(EarnSteps_styles_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});
const cardPadding = "32px";
const Card = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-349b21eb-3"
})(EarnSteps_styles_templateObject3(), cardPadding, cardPadding, (param)=>{
    let { theme: { colors: { functional: { white  }  }  }  } = param;
    return white;
}, (param)=>{
    let { theme: { boxShadow: { blue  }  }  } = param;
    return blue;
}, (param)=>{
    let { theme: { colors: { primary: { main  }  }  }  } = param;
    return main;
});
const CardImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-349b21eb-4"
})(EarnSteps_styles_templateObject4(), cardPadding, cardPadding, cardPadding, cardPadding, cardPadding);

;// CONCATENATED MODULE: ./public/logo-curve.png
/* harmony default export */ var logo_curve = ({"src":"/_next/static/media/logo-curve.0efa7a9e.png","height":232,"width":234,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAZlBMVEVMaXH/cwClAAZ9/3i/+DnyOhLethyL/2oAtv8l9s5E/rEJ/+1r/Yv/wwAu88kAWv8AO/+z/0T/eAAFx/XuAAG0BwDbAADM8S3/qwFz+oOkAADS+ybwzgsJxvL8sQKjAQDwLwD/UACpjM1TAAAAG3RSTlMA9R4R+Aj8/hkDiTrun7fJT/mE1Vne+VZIMX8Pa5JIAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAQUlEQVQImR2KNwKAIBDAAgIn9t6w/v+TKhmSJaC3QQPY8XpUZ2G5Jxf2EuZTuTaYhFXESJGB748qT/+7qWMi/tMLa8UCfjnmVrkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./components/icons/index.js + 56 modules
var icons = __webpack_require__(2667);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./pages/earn/EarnSteps.tsx







function EarnSteps() {
    const [loaded, setLoaded] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setLoaded(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepsWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "How do I Provide Liquidity?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardImage, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: logo_curve,
                                    width: 90,
                                    height: 90,
                                    alt: "Curve Logo"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Go to the 3CRV/lvUSD Curve Pool"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardImage, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/earn/StableCoins.svg",
                                    alt: "",
                                    width: 86,
                                    height: 80
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Deposit and Stake USDC, USDT, or DAI"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardImage, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LogoArch */.cB, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Earn rewards in ARCH Tokens"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepsButtons, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        target: "_blank",
                        href: "https://curve.fi/#/ethereum/pools/factory-v2-268/deposit",
                        variant: "button",
                        children: "Provide Liquidity on Curve"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "https://docs.archimedesfi.com/liquidity-providing-(lender)/how-to-provide-liquidity-(step-by-step)",
                        variant: "outline",
                        children: "Step by Step Guide"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/common/Container/index.tsx + 1 modules
var Container = __webpack_require__(7987);
;// CONCATENATED MODULE: ./pages/earn/EarnFAQ.styles.ts

function EarnFAQ_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n"
    ]);
    EarnFAQ_styles_templateObject = function() {
        return data;
    };
    return data;
}
function EarnFAQ_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 120px 0;\n  width: 810px;\n  @media (max-width: ",
        ") {\n    padding: 80px 0;\n    width: 90%;\n    max-width: ",
        ";\n  }\n"
    ]);
    EarnFAQ_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function EarnFAQ_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  margin-bottom: 16px;\n"
    ]);
    EarnFAQ_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function EarnFAQ_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  padding: 32px;\n  cursor: pointer;\n  position: relative;\n  svg {\n    position: relative;\n    top: 6px;\n    display: inline-block;\n    height: 24px;\n    width: 24px;\n    fill: ",
        ";\n  }\n  @media (max-width: ",
        ") {\n    padding-right: 64px;\n    svg {\n      position: absolute;\n      right: 32px;\n      top: 32px;\n    }\n  }\n"
    ]);
    EarnFAQ_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function EarnFAQ_styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 32px 32px 32px;\n  margin-bottom: 8px;\n  display: none;\n  p {\n    font-size: 16px;\n  }\n  p:last-child {\n    margin-bottom: 0;\n  }\n  ul {\n    list-style: disc;\n    margin-left: 24px;\n    margin-bottom: 24px;\n  }\n  a {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    EarnFAQ_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 12px;\n  margin-bottom: 24px;\n  :hover {\n    background: ",
        ";\n    box-shadow: ",
        ";\n  }\n  &:hover ",
        " {\n    color: ",
        ";\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}



const FaqWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9eb9ff2d-0"
})(EarnFAQ_styles_templateObject(), (param)=>{
    let { theme: { colors: { primary: { lightest  }  }  }  } = param;
    return lightest;
});
const FaqContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-9eb9ff2d-1"
})(EarnFAQ_styles_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.container.md;
});
const Title = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
    componentId: "sc-9eb9ff2d-2"
})(EarnFAQ_styles_templateObject2());
const Head = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9eb9ff2d-3"
})(EarnFAQ_styles_templateObject3(), (param)=>{
    let { theme: { colors: { primary: { main  }  }  }  } = param;
    return main;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9eb9ff2d-4"
})(EarnFAQ_styles_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
});
const FaqItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9eb9ff2d-5"
})(_templateObject5(), (param)=>{
    let { theme: { colors: { primary: { lightestMore  }  }  }  } = param;
    return lightestMore;
}, (param)=>{
    let { theme: { colors: { functional: { white  }  }  }  } = param;
    return white;
}, (param)=>{
    let { theme: { boxShadow: { blue  }  }  } = param;
    return blue;
}, Head, (param)=>{
    let { theme: { colors: { primary: { main  }  }  }  } = param;
    return main;
}, (param)=>{
    let { isOpen , theme: { colors: { primary: { main  } , functional: { white  }  } , boxShadow: { blue  }  }  } = param;
    return isOpen && "\n    background: ".concat(white, ";\n    box-shadow: ").concat(blue, ";\n    ").concat(Head, " {\n      color: ").concat(main, ";\n      svg {\n        transform: rotate(180deg);\n      }\n    }\n    ").concat(Body, " {\n      display: block;\n    }\n  ");
});

;// CONCATENATED MODULE: ./pages/earn/EarnFAQ.tsx





function EarnFAQ() {
    /// We start at 1, so 0 can allow all to start closed
    const [openIndex, setOpenIndex] = (0,react.useState)(0);
    const clickHandler = (index)=>{
        setOpenIndex(openIndex === index ? 0 : index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FaqContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    type: "h1",
                    children: "FAQ"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FaqItem, {
                    isOpen: openIndex === 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Head, {
                            onClick: ()=>clickHandler(1),
                            children: [
                                "Where is the liquidity pool APY coming from? ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconChevron */.g6, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Our ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: "3CRV/lvUSD Pool APY"
                                        }),
                                        " is achieved from emission rewards from our native ARCH Token. Additional APY will come in the form of OUSD and the different protocols we support (as well as CRV). ARCH actually has utility as well as being our governance token."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Leverage Takers (Borrowers) can only open a leverage position by purchasing leverage (lvUSD) with ARCH. With this leverage fee we hope create high demand for ARCH tokens."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FaqItem, {
                    isOpen: openIndex === 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Head, {
                            onClick: ()=>clickHandler(2),
                            children: [
                                "Why should I provide liquidity to Archimedes? ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconChevron */.g6, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "At Archimedes we are obsessively focused on providing small and large Liquidity providers with:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: "Top of market APY"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: "Sustainable APY"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "You can read more about how we achieve this",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: "https://docs.archimedesfi.com/liquidity-providing-(lender)/why-provide-liquidity-with-archimedes",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: "here."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FaqItem, {
                    isOpen: openIndex === 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Head, {
                            onClick: ()=>clickHandler(3),
                            children: [
                                "How much APY am I going to get as a LP?",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconChevron */.g6, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "This is hard to predict but we aim to provide a ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: "Top of Market APY."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "We use an innovative and Dynamic ARCH Emission schedule, you can read more about it",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: "https://docs.archimedesfi.com/tokenomics-and-ecosystem/arch-dynamic-emissions",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: "here."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FaqItem, {
                    isOpen: openIndex === 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Head, {
                            onClick: ()=>clickHandler(4),
                            children: [
                                "How can I be sure that lvUSD will remain pegged?",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconChevron */.g6, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Read more about how we maintain the peg for lvUSD",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://docs.archimedesfi.com/liquidity-providing-(lender)/risks-of-providing-liquidity#0f9e44d0755a40b88c0f1a7857a5cfb3",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "here"
                                    }),
                                    "."
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FaqItem, {
                    isOpen: openIndex === 5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Head, {
                            onClick: ()=>clickHandler(5),
                            children: [
                                "How do I provide liquidity?",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconChevron */.g6, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Read our Step-by-Step guide to providing liquidity",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://docs.archimedesfi.com/liquidity-providing-(lender)/how-to-provide-liquidity-(step-by-step)",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "here"
                                    }),
                                    "."
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./pages/earn/earn.styles.ts

function earn_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  > div {\n    position: relative;\n    z-index: 1;\n  }\n  ::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    height: 100%;\n    background: url('/earn/background-cropped.svg') left center no-repeat;\n    background-size: cover;\n    z-index: 0;\n  }\n"
    ]);
    earn_styles_templateObject = function() {
        return data;
    };
    return data;
}

const EarnTopWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-566b2dd0-0"
})(earn_styles_templateObject());

;// CONCATENATED MODULE: ./pages/earn/index.page.tsx







function Earn() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Earn as LP"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "About ArchimedesFi. Our team and values."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EarnTopWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EarnHero, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EarnSteps, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EarnFAQ, {})
                ]
            })
        ]
    });
}


/***/ }),

/***/ 7857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(7294);
var countup_js = __webpack_require__(8273);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/**
 * Silence SSR Warnings.
 * Borrowed from Formik v2.1.1, Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? React.useLayoutEffect : React.useEffect;

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Create a stable reference to a callback which is updated after each render is committed.
 * Typed version borrowed from Formik v2.2.1. Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */
function useEventCallback(fn) {
  var ref = React.useRef(fn);

  // we copy a ref to the callback scoped to the current state/props on each render
  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current.apply(void 0, args);
  }, []);
}

var createCountUpInstance = function createCountUpInstance(el, props) {
  var decimal = props.decimal,
    decimals = props.decimals,
    duration = props.duration,
    easingFn = props.easingFn,
    end = props.end,
    formattingFn = props.formattingFn,
    numerals = props.numerals,
    prefix = props.prefix,
    separator = props.separator,
    start = props.start,
    suffix = props.suffix,
    useEasing = props.useEasing,
    enableScrollSpy = props.enableScrollSpy,
    scrollSpyDelay = props.scrollSpyDelay,
    scrollSpyOnce = props.scrollSpyOnce;
  return new countup_js.CountUp(el, end, {
    startVal: start,
    duration: duration,
    decimal: decimal,
    decimalPlaces: decimals,
    easingFn: easingFn,
    formattingFn: formattingFn,
    numerals: numerals,
    separator: separator,
    prefix: prefix,
    suffix: suffix,
    useEasing: useEasing,
    useGrouping: !!separator,
    enableScrollSpy: enableScrollSpy,
    scrollSpyDelay: scrollSpyDelay,
    scrollSpyOnce: scrollSpyOnce
  });
};

var _excluded$1 = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"];
var DEFAULTS = {
  decimal: '.',
  delay: null,
  prefix: '',
  suffix: '',
  duration: 2,
  start: 0,
  startOnMount: true,
  enableReinitialize: true
};
var useCountUp = function useCountUp(props) {
  var _useMemo = React.useMemo(function () {
      return _objectSpread2(_objectSpread2({}, DEFAULTS), props);
    }, [props]),
    ref = _useMemo.ref,
    startOnMount = _useMemo.startOnMount,
    enableReinitialize = _useMemo.enableReinitialize,
    delay = _useMemo.delay,
    onEnd = _useMemo.onEnd,
    onStart = _useMemo.onStart,
    onPauseResume = _useMemo.onPauseResume,
    onReset = _useMemo.onReset,
    onUpdate = _useMemo.onUpdate,
    instanceProps = _objectWithoutProperties(_useMemo, _excluded$1);
  var countUpRef = React.useRef();
  var timerRef = React.useRef();
  var isInitializedRef = React.useRef(false);
  var createInstance = useEventCallback(function () {
    return createCountUpInstance(typeof ref === 'string' ? ref : ref.current, instanceProps);
  });
  var getCountUp = useEventCallback(function (recreate) {
    var countUp = countUpRef.current;
    if (countUp && !recreate) {
      return countUp;
    }
    var newCountUp = createInstance();
    countUpRef.current = newCountUp;
    return newCountUp;
  });
  var start = useEventCallback(function () {
    var run = function run() {
      return getCountUp(true).start(function () {
        onEnd === null || onEnd === void 0 ? void 0 : onEnd({
          pauseResume: pauseResume,
          reset: reset,
          start: restart,
          update: update
        });
      });
    };
    if (delay && delay > 0) {
      timerRef.current = setTimeout(run, delay * 1000);
    } else {
      run();
    }
    onStart === null || onStart === void 0 ? void 0 : onStart({
      pauseResume: pauseResume,
      reset: reset,
      update: update
    });
  });
  var pauseResume = useEventCallback(function () {
    getCountUp().pauseResume();
    onPauseResume === null || onPauseResume === void 0 ? void 0 : onPauseResume({
      reset: reset,
      start: restart,
      update: update
    });
  });
  var reset = useEventCallback(function () {
    // Quick fix for https://github.com/glennreyes/react-countup/issues/736 - should be investigated
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (getCountUp().el) {
      timerRef.current && clearTimeout(timerRef.current);
      getCountUp().reset();
      onReset === null || onReset === void 0 ? void 0 : onReset({
        pauseResume: pauseResume,
        start: restart,
        update: update
      });
    }
  });
  var update = useEventCallback(function (newEnd) {
    getCountUp().update(newEnd);
    onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
      pauseResume: pauseResume,
      reset: reset,
      start: restart
    });
  });
  var restart = useEventCallback(function () {
    reset();
    start();
  });
  var maybeInitialize = useEventCallback(function (shouldReset) {
    if (startOnMount) {
      if (shouldReset) {
        reset();
      }
      start();
    }
  });
  React.useEffect(function () {
    if (!isInitializedRef.current) {
      isInitializedRef.current = true;
      maybeInitialize();
    } else if (enableReinitialize) {
      maybeInitialize(true);
    }
  }, [enableReinitialize, isInitializedRef, maybeInitialize, delay, props.start, props.suffix, props.prefix, props.duration, props.separator, props.decimals, props.decimal, props.formattingFn]);
  React.useEffect(function () {
    return function () {
      reset();
    };
  }, [reset]);
  return {
    start: restart,
    pauseResume: pauseResume,
    reset: reset,
    update: update,
    getCountUp: getCountUp
  };
};

var _excluded = ["className", "redraw", "containerProps", "children", "style"];
var CountUp = function CountUp(props) {
  var className = props.className,
    redraw = props.redraw,
    containerProps = props.containerProps,
    children = props.children,
    style = props.style,
    useCountUpProps = _objectWithoutProperties(props, _excluded);
  var containerRef = React.useRef(null);
  var isInitializedRef = React.useRef(false);
  var _useCountUp = useCountUp(_objectSpread2(_objectSpread2({}, useCountUpProps), {}, {
      ref: containerRef,
      startOnMount: typeof children !== 'function' || props.delay === 0,
      // component manually restarts
      enableReinitialize: false
    })),
    start = _useCountUp.start,
    reset = _useCountUp.reset,
    updateCountUp = _useCountUp.update,
    pauseResume = _useCountUp.pauseResume,
    getCountUp = _useCountUp.getCountUp;
  var restart = useEventCallback(function () {
    start();
  });
  var update = useEventCallback(function (end) {
    if (!props.preserveValue) {
      reset();
    }
    updateCountUp(end);
  });
  var initializeOnMount = useEventCallback(function () {
    if (typeof props.children === 'function') {
      // Warn when user didn't use containerRef at all
      if (!(containerRef.current instanceof Element)) {
        console.error("Couldn't find attached element to hook the CountUp instance into! Try to attach \"containerRef\" from the render prop to a an Element, eg. <span ref={containerRef} />.");
        return;
      }
    }

    // unlike the hook, the CountUp component initializes on mount
    getCountUp();
  });
  React.useEffect(function () {
    initializeOnMount();
  }, [initializeOnMount]);
  React.useEffect(function () {
    if (isInitializedRef.current) {
      update(props.end);
    }
  }, [props.end, update]);
  var redrawDependencies = redraw && props;

  // if props.redraw, call this effect on every props change
  React.useEffect(function () {
    if (redraw && isInitializedRef.current) {
      restart();
    }
  }, [restart, redraw, redrawDependencies]);

  // if not props.redraw, call this effect only when certain props are changed
  React.useEffect(function () {
    if (!redraw && isInitializedRef.current) {
      restart();
    }
  }, [restart, redraw, props.start, props.suffix, props.prefix, props.duration, props.separator, props.decimals, props.decimal, props.className, props.formattingFn]);
  React.useEffect(function () {
    isInitializedRef.current = true;
  }, []);
  if (typeof children === 'function') {
    // TypeScript forces functional components to return JSX.Element | null.
    return children({
      countUpRef: containerRef,
      start: start,
      reset: reset,
      update: updateCountUp,
      pauseResume: pauseResume,
      getCountUp: getCountUp
    });
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    className: className,
    ref: containerRef,
    style: style
  }, containerProps), typeof props.start !== 'undefined' ? getCountUp().formattingFn(props.start) : '');
};

exports.ZP = CountUp;
__webpack_unused_export__ = useCountUp;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,774,888,179], function() { return __webpack_exec__(5161); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);